import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { exportOrders, getMeistarklases, getMeistarklasesApmekletaji, getZurnaliGramatas, sendCoupons } from '../features/order/orderSlice';
import Spinner from '../components/Spinner';
import { MdAttachEmail, MdPercent } from "react-icons/md";
import { FaTimes } from "react-icons/fa";
import { toast } from 'react-toastify';

function Meistarklases() {
    const dispatch = useDispatch();

    const { products, meistarklases, orders, isLoading, isError } = useSelector((state) => state.order);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [datumi, setDatumi] = useState([]);
    const [selectedProductRadio, setSelectedProductRadio] = useState(null); // Initialize selectedProductRadio state

    const [isExporting, setIsExporting] = useState(false);
    const [isCouponing, setIsCouponing] = useState(false);

    const [admin_email, setAdminEmail] = useState('');
    const [emailHeading, setEmailHeading] = useState('');

    useEffect(() => {
        if (meistarklases) {
            // Add all variations and their parent id as objects to the datumi array
            let temp = [];

            meistarklases.forEach((meistarklase) => {
                let tempObj = {
                    id: meistarklase.parent_product.id,
                    name: `${meistarklase.parent_product.name} - ${meistarklase.name}`, // Combine meistarklase name and variation name
                    variation_id: meistarklase.id,
                    actual_name: meistarklase.name,
                };
                temp.push(tempObj);
            });
            setDatumi(temp);
        }
    }, [meistarklases, products]);

    useEffect(() => {
        dispatch(getMeistarklases());
    }, [dispatch]);

    const handleGetMeistarklasesCilveki = () => {
        if (selectedProduct === null) return;
        const selected_date = datumi.find((datums) => datums.variation_id === selectedProduct);
        dispatch(getMeistarklasesApmekletaji(selected_date));
    };

    const getProducts = async () => {
        dispatch(getZurnaliGramatas());
    };

    const handleSelectChange = (e) => {
        setSelectedProduct(parseInt(e.target.value, 10));
    };

    const handleRadioChange = (product) => {
        setSelectedProductRadio(product);
    };

    const handleSendCoupons = () => {
        if(!isCouponing || !selectedProductRadio || !orders) { 
            return;
        }

        if(!admin_email) {
            toast.error('Ievadiet admin e-pastu');
            return; 
        }

        const data = {
            products: [selectedProductRadio],
            admin_email: admin_email,
            email_heading: emailHeading,
            orders: orders,
        }

        dispatch(sendCoupons(data));
    };

    const handleExportData = () => {
        if(!admin_email || !orders) {
            toast.error('Ievadiet admin e-pastu');
            return;
        }

        const data = {
            admin_email: admin_email,
            orders: orders,
        }

        dispatch(exportOrders(data));
    };


    if (isLoading) return <Spinner />;
    return (
        <div className='padding-20-top flex column gap-10 padding-20-bottom'>
            <div className="select-box flex gap-10">
                <select className='basic' name="" id="" value={selectedProduct} onChange={handleSelectChange}>
                    <option value="" disabled>Izvēlies datumu</option>
                    {datumi.map((datums) => (
                        <option key={datums.variation_id} value={datums.variation_id}>
                            {datums.name}
                        </option>
                    ))}
                </select>

                <button className="btn poga" onClick={() => handleGetMeistarklasesCilveki()}>Apskatīt apmeklētājus</button>
            </div>

            <table className='meistarklase-apmekletaji-table'>
                <thead>
                    <tr>
                        <th className='sk'>Skaits</th>
                        <th className='name'>Vārds</th>
                        <th className='title'>Nosaukums</th>
                        <th className='phone'>Telefons</th>
                        <th className='email'>E-pasts</th>
                        <th className='coupon'>Kupons</th>
                        <th className='comment'>Komentārs</th>
                        <th className='payment'>Apmaksāja</th>
                    </tr>
                </thead>
                <tbody>
                    {orders && orders.map((order) => (
                        <tr key={order.id} className={order.completed ? 'completed' : 'in-progress'}>
                            <td className='sk'>{order.quantity}</td>
                            <td className='name'><b>#{order.id}</b> {order.name}</td>
                            <td className='title'>{order.title}</td>
                            <td className='phone'>{order.phone}</td>
                            <td className='email'>{order.email}</td>
                            <td className='coupon'>{order.coupon || '-'}</td>
                            <td className='comment'>{order.comment}</td>
                            <td className='payment'>{order.payment}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {orders && orders.length > 0 && 
                <div className="flex gap-10 padding-10-top">
                    <button className="btn poga" onClick={() => {
                        setIsExporting(!isExporting);
                        // setIsCouponing(false);
                    }}>
                        {isExporting ? <FaTimes /> : <MdAttachEmail />}
                        Eksportēt
                    </button>
                    {/* <button className="btn poga" onClick={() => {
                        if (!isCouponing) getProducts();
                        setIsCouponing(!isCouponing);
                        setIsExporting(false);
                        setSelectedProductRadio(null);
                    }}>
                        {isCouponing ? <FaTimes /> : <MdPercent />}
                        Kuponi
                    </button> */}
                </div>
            }

            {isExporting && 
                <div className="flex gap-10 padding-10-top">
                    <input type="text" className="basic width-100" placeholder='Admin e-pasts' value={admin_email} onChange={(e) => setAdminEmail(e.target.value)}/>
                    <button className="btn poga" onClick={handleExportData}>Eksportēt</button>
                </div>
            }
            
            
{/* 
            {isCouponing &&
                <div className="flex column couponing ">
                    {products && products.map((product) => (
                        <div key={product.id} className="couponing-item padding-10-top">
                            <input
                                type="radio"
                                checked={selectedProductRadio && selectedProductRadio.id === product.id}
                                onChange={() => handleRadioChange(product)}
                            />
                            <label htmlFor="" className='padding-10-left'>{product.name}</label>
                        </div>
                    ))}
                    <div className="flex padding-20-top">
                        <input type="text" className='basic width-100' placeholder='E-pasta virsraksts' value={emailHeading} onChange={(e) => setEmailHeading(e.target.value)}/>
                    </div>
                    <div className="flex gap-10 padding-10-top">
                        <input type="text" className="basic width-100" placeholder='Admin e-pasts' value={admin_email} onChange={(e) => setAdminEmail(e.target.value)}/>
                        <button className="btn poga" onClick={handleSendCoupons}>Nosūtīt</button>
                    </div>
                </div>
            } */}
        </div>
    );
}

export default Meistarklases;